import sharedFormatters from "@shared/formatters.cjs";

const { formatKoreanPriceText } = sharedFormatters;

export function normalizePrice(value) {
  return String(value || "")
    .replace(/[^\d]/g, "")
    .replace(/^0+/, "");
}

export function formatPriceWithCommas(value) {
  const price = normalizePrice(value);
  return price ? price.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "";
}

export function normalizeEstimateReplyPrice(value) {
  const permittedValue = String(value || "").replace(/[^\d~]/g, "");
  const [minimumPrice, ...maximumPriceParts] = permittedValue.split("~");
  if (!maximumPriceParts.length) return normalizePrice(minimumPrice);

  return `${normalizePrice(minimumPrice)}~${normalizePrice(
    maximumPriceParts.join("")
  )}`;
}

export function formatEstimateReplyPriceInput(value) {
  return normalizeEstimateReplyPrice(value)
    .split("~")
    .map((price) => formatPriceWithCommas(price))
    .join("~");
}

export const formatEstimateReplyPriceInKorean = formatKoreanPriceText;

export function isValidEstimateReplyPrice(value) {
  return /^\d+(?:~\d+)?$/.test(normalizeEstimateReplyPrice(value));
}
